<div class="bg-(--toolbar-color) h-[50px]">
  <div class="w-full max-w-6xl mx-auto px-4 h-full flex flex-row justify-between items-center">
    <span class="text-white">
      <a [routerLink]="['/projects', projectView()?.id]" aria-label="Back to projects" i18n-aria-label
        class="size-fit flex flex-row items-center">
        <mat-icon class="size-fit! text-base! text-inherit!">arrow_back</mat-icon>
        <span class="text-sm italic" i18n>back to project detail</span>
      </a>
    </span>
    <span class="mr-5">
      @if (hasAssignedReports() && permissions.canModify()) {
      <a class="bg-(--brand-button-active-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
        aria-label="Invite Participants" [routerLink]="['/projects', projectView()?.id, 'invite']"
        [state]="{ showLoading: false }">
        Invite Participants
      </a>
      }
    </span>
  </div>
</div>
<div class="w-full max-w-6xl mx-auto px-4 flex flex-col text-(--toolbar-color)">
  <span class="text-base font-semibold py-4">{{ projectView()?.name }}</span>
</div>
<div class="w-full bg-(--download-bar-color) text-white">
  <div class="w-full max-w-6xl mx-auto px-4 h-10 flex items-center">
    @if (hasAnyPotentialReports()) {
    <button matFab extended type="button" [disabled]="downloading()" (click)="download()">
      <mat-icon class="text-base! text-inherit!">download_2</mat-icon>
      <span class="text-sm" i18n>download reports</span>
    </button>
    }
  </div>
</div>
<div class="w-full max-w-6xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-[70%_30%] lg:grid-rows-[1fr_auto]">
  <!-- Below lg the list yields the screen to the detail; from lg up both show. -->
  <div [class]="hasSelection() ? 'hidden lg:block min-w-0' : 'min-w-0'">
    <mat-table [dataSource]="viewData()" matSort aria-label="Project participants" i18n-aria-label
        class="h-[60dvh] lg:h-[calc(100dvh-196px)] overflow-y-auto overflow-x-auto">
      <!-- First Name Column -->
      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="firstName" i18n>First Name</mat-header-cell>
        <mat-cell *matCellDef="let p">{{ p.firstName }}</mat-cell>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="lastName" i18n>Last Name</mat-header-cell>
        <mat-cell *matCellDef="let p">{{ p.lastName }}</mat-cell>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header="email" i18n>Email</mat-header-cell>
        <mat-cell *matCellDef="let p">{{ p.email }}</mat-cell>
      </ng-container>

      <!-- Completion Dates Column -->
      <ng-container matColumnDef="completionDates">
        <mat-header-cell *matHeaderCellDef mat-sort-header="completionDates" i18n>Completed</mat-header-cell>
        <mat-cell *matCellDef="let p">
          @if(p.completed == p.total) {
          {{ p.latest | date }}
          }@else{
          {{ p.completed + ' of ' + p.total }}
          }
        </mat-cell>
      </ng-container>

      <!-- Secondary Column -->
      <ng-container matColumnDef="footer">
        <mat-footer-cell colspan="3" *matFooterCellDef colspan="3">
          <mat-paginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons
            aria-label="Participant table pagination" i18n-aria-label class="col-span-2 h-[50px]"></mat-paginator>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="['firstName', 'lastName', 'email', 'completionDates']; sticky: true"></mat-header-row>
      <mat-row matRipple *matRowDef="let row; columns: ['firstName', 'lastName', 'email', 'completionDates']"
        class="clickable-row" (click)="selectParticipant(row)"></mat-row>
      <mat-footer-row *matFooterRowDef="['footer']; sticky: true"></mat-footer-row>
    </mat-table>
  </div>
  <div [class]="hasSelection() ? 'bg-[#e7ebec] min-w-0' : 'hidden lg:block bg-[#e7ebec] min-w-0'">
    @if (hasSelection()) {
    <button type="button" (click)="closeParticipant()"
      class="lg:hidden w-full flex flex-row items-center gap-1 px-4 py-3 text-(--toolbar-color) font-semibold text-sm border-b border-b-(--hr-color) bg-transparent"
      aria-label="Close participant detail" i18n-aria-label>
      <mat-icon class="size-fit! text-base! text-inherit!" aria-hidden="true">arrow_back</mat-icon>
      <span i18n>Back to participants</span>
    </button>
    }
    <router-outlet></router-outlet>
  </div>
</div>